import { useMemo, useEffect } from 'react'
import commonApi from 'src/api/commonApi'
import { useSelector, useDispatch } from 'react-redux'

import { setCategories } from 'src/redux/actions/categoriesAction'
import { CATEGORY_TYPE } from 'src/libs/constant'
import calendarConfigApi from 'src/api/calendarApi'
import useGetWithContext from './useGetWithContext'
import centerApi from 'src/api/centerApi'

export function useGetCategories (type) {
  const dispatch = useDispatch()

  const categoriesList = useSelector((state) => state.categories[type])

  const categories = useMemo(() => {
    return categoriesList
  }, [categoriesList, type])

  const api = useMemo(() => {
    switch (type) {
      case CATEGORY_TYPE.GRADE:
        return commonApi.getGrade
      case CATEGORY_TYPE.LEVEL:
        return commonApi.getLevel
      case CATEGORY_TYPE.DEVICE:
        return commonApi.getDevice
      case CATEGORY_TYPE.PROVINCE:
        return commonApi.getProvince
      case CATEGORY_TYPE.REGION:
        return commonApi.getRegion
      case CATEGORY_TYPE.SUBJECT:
        return commonApi.getSubject
      case CATEGORY_TYPE.STUDY_PROGRAM:
        return commonApi.getStudyProgram
      case CATEGORY_TYPE.CRM_PACKAGE:
        return commonApi.getCrmPackage
      case CATEGORY_TYPE.CLASS_TIME_SLOT:
        return calendarConfigApi.findAllTimeSlot
      case CATEGORY_TYPE.COUNTRY_PHONE:
        return commonApi.getCountryPhoneNumber
      case CATEGORY_TYPE.CENTER:
        return centerApi.getListCenterNotRole
      case CATEGORY_TYPE.VIOLATION_LEVEL:
        return commonApi.getViolationLevel
    }
  }, [type])

  const { data: categoriesNew } = useGetWithContext(
    `FIND_ALL_${type}`,
    api,
    null,
    {
      isDisabled: !!categories || !type || !api
    }
  )

  useEffect(() => {
    if (categoriesNew) {
      const tempCategories = {}
      tempCategories[type] = categoriesNew
      dispatch(setCategories(tempCategories))
    }
  }, [categoriesNew])

  return categories
}
